import {
  FETCH_VIDEO_EARNINGS_REQUEST,
  FETCH_TIP_EARNINGS_REQUEST,
  FETCH_SUBS_EARNINGS_REQUEST,
  FETCH_PAID_EARNINGS_REQUEST,
  FETCH_LIVESTREAM_EARNINGS_REQUEST
} from "./ActionConstant";

// Action Creators

export const fetchVideoEarnings = (payload) => ({
  type: FETCH_VIDEO_EARNINGS_REQUEST,
  payload,
});

export const fetchTipEarnings = (payload) => ({
  type: FETCH_TIP_EARNINGS_REQUEST,
  payload,
});

export const fetchSubsEarnings = (payload) => ({
  type: FETCH_SUBS_EARNINGS_REQUEST,
  payload,
});

export const fetchPaidPostEarnings = (payload) => ({
  type: FETCH_PAID_EARNINGS_REQUEST,
  payload,
});

export const fetchLiveStreamEarnings = (payload) => ({
  type: FETCH_LIVESTREAM_EARNINGS_REQUEST,
  payload,
});